import * as types from '../constants/ActionTypes.js';
import { ROOT_URL } from '../constants/Config.js';

import axios from 'axios';

export function setScrollTop(scrollTop) {
  return {
    type: types.SET_SCROLL_TOP,
    payload: scrollTop,
  };
}

let recent;

export function loadData(isList, search, clear) {
  recent = search;
  const isRecent = () => search === recent;
  const OBJECTS = isList ? 'OBJECTS' : 'PINS';

  return (dispatch) => {
    dispatch({
      type: types[`LOAD_${OBJECTS}_START`],
      ...(isRecent() && { meta: { loader: true } }),
    });

    const request = () => {
      if (isRecent()) {
        const path = isList ? `${ROOT_URL}/buildings/search` : `${ROOT_URL}/buildings/pin`;
        const userUid = localStorage.getItem('public');
        axios
          .post(path, { ...search, userUid })
          .then((data) => {
            if (isRecent()) {
              dispatch({
                type: types[`LOAD_${OBJECTS}_SUCCESS`],
                payload: { data: data.data, clear },
                meta: { loader: true },
              });
            }
          })
          .catch((error) => {
            if (isRecent()) {
              dispatch({
                type: types[`LOAD_${OBJECTS}_ERROR`],
                payload: error,
                meta: { loader: true },
              });
            }
          });
      }
    };

    return clear ? setTimeout(request, 100) : request();
  };
}

export const resetObjects = () => ({
  type: types.RESET_OBJECTS,
});

export function loadPoint(id) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_POINT_START });
    axios
      .get(`${ROOT_URL}/buildings/building?id=${id}`)
      .then((data) => {
        dispatch({ type: types.LOAD_POINT_SUCCESS, payload: { id, data: data.data } });
      })
      .catch((error) => {
        dispatch({ type: types.LOAD_POINT_ERROR, payload: error });
      });
  };
}

export function loadPointList(ids, longLat) {
  return (dispatch) => {
    dispatch({ type: types.LOAD_POINT_LIST_START });

    const encodedIds = encodeURIComponent(ids.join(','));

    axios
      .get(`${ROOT_URL}/buildings/listById?ids=${encodedIds}`)
      .then((data) => {
        dispatch({
          type: types.LOAD_POINT_LIST_SUCCESS,
          payload: { id: longLat, data: data.data },
        });
      })
      .catch((error) => {
        dispatch({ type: types.LOAD_POINT_LIST_ERROR, payload: error });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/objects.js